import React from 'react';
import logo from "../../images/logotype.png";




const HomeLogo = () => {

    const href = "/home";
    return (
        <a className="navbar-brand ros-navbar-brand p-0" href={href}>
            <img className="logo" src={logo} alt="logo"/>
        </a>
    );
};

export default HomeLogo;
